import React, { useState } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official'; 
import { Button, Stack } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
const allMembers = [
  {
    name: 'Faizal W.',
    tracked: '9:08:46',
    manual: '0:00:00',
    hours: 48,
    image: 'https://i.pravatar.cc/150?img=1',
  },
  {
    name: 'Eleanor P.',
    tracked: '8:50:00',
    manual: '0:10:00',
    hours: 50,
    image: 'https://i.pravatar.cc/150?img=2',
  },
  {
    name: 'Floyd M.',
    tracked: '9:15:30',
    manual: '0:00:00',
    hours: 55,
    image: 'https://i.pravatar.cc/150?img=3',
  },
  {
    name: 'Dianne R.',
    tracked: '7:30:45',
    manual: '0:20:00',
    hours: 32,
    image: 'https://i.pravatar.cc/150?img=4',
  },
  {
    name: 'Darlene R.',
    tracked: '8:44:00',
    manual: '0:00:00',
    hours: 44,
    image: 'https://i.pravatar.cc/150?img=5',
  },
  {
    name: 'Kristin W.',
    tracked: '6:00:00',
    manual: '0:00:00',
    hours: 30,
    image: 'https://i.pravatar.cc/150?img=6',
  },
  {
    name: 'Jenny W.',
    tracked: '7:15:15',
    manual: '0:00:00',
    hours: 33,
    image: 'https://i.pravatar.cc/150?img=7',
  },
  {
    name: 'Guy H.',
    tracked: '6:30:00',
    manual: '0:30:00',
    hours: 35,
    image: 'https://i.pravatar.cc/150?img=8',
  },
  {
    name: 'Annette B.',
    tracked: '7:40:00',
    manual: '0:00:00',
    hours: 42,
    image: 'https://i.pravatar.cc/150?img=9',
  },
  {
    name: 'Cody F.',
    tracked: '9:30:00',
    manual: '0:00:00',
    hours: 58,
    image: 'https://i.pravatar.cc/150?img=10',
  },
  {
    name: 'Ronald R.',
    tracked: '7:20:20',
    manual: '0:00:00',
    hours: 40,
    image: 'https://i.pravatar.cc/150?img=11',
  },
  {
    name: 'Esther H.',
    tracked: '6:55:00',
    manual: '0:00:00',
    hours: 34,
    image: 'https://i.pravatar.cc/150?img=12',
  },
  {
    name: 'Kathryn M.',
    tracked: '8:45:45',
    manual: '0:00:00',
    hours: 53,
    image: 'https://i.pravatar.cc/150?img=13',
  },
  {
    name: 'Robert F.',
    tracked: '6:40:00',
    manual: '0:00:00',
    hours: 41,
    image: 'https://i.pravatar.cc/150?img=14',
  },
  {
    name: 'Darrell S.',
    tracked: '5:00:00',
    manual: '0:00:00',
    hours: 20,
    image: 'https://i.pravatar.cc/150?img=15',
  },
  {
    name: 'Albert F.',
    tracked: '9:00:00',
    manual: '0:00:00',
    hours: 57,
    image: 'https://i.pravatar.cc/150?img=16',
  },
  {
    name: 'Jacob J.',
    tracked: '8:05:05',
    manual: '0:00:00',
    hours: 45,
    image: 'https://i.pravatar.cc/150?img=17',
  },
  {
    name: 'Jacob J.',
    tracked: '8:05:05',
    manual: '0:00:00',
    hours: 45,
    image: 'https://i.pravatar.cc/150?img=17',
  },
  {
    name: 'Jacob J.',
    tracked: '8:05:05',
    manual: '0:00:00',
    hours: 45,
    image: 'https://i.pravatar.cc/150?img=17',
  },
  {
    name: 'Jacob J.',
    tracked: '8:05:05',
    manual: '0:00:00',
    hours: 45,
    image: 'https://i.pravatar.cc/150?img=17',
  },
  {
    name: 'Jacob J.',
    tracked: '8:05:05',
    manual: '0:00:00',
    hours: 45,
    image: 'https://i.pravatar.cc/150?img=17',
  },
];

const MemberUsageBarChart = () => {
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = 20;

  const visibleMembers = allMembers.slice(startIndex, startIndex + visibleCount);

  const handlePrev = () => {
    if (startIndex > 0) setStartIndex(startIndex - 20);
  };

  const handleNext = () => {
    if (startIndex + visibleCount < allMembers.length)
      setStartIndex(startIndex + 20);
  };

  const options = {
    chart: {
      type: 'column',
      height: 500,
      backgroundColor: 'transparent',
      animation: true,
    },
    credits: { enabled: false },
    title: { text: null },
    xAxis: {
      categories: visibleMembers.map((item) => item.name),
      labels: {
        style: {
          fontSize: '12px',
          fontFamily: 'Manrope',
        },
      },
    },
    yAxis: {
      min: 0,
      title: { text: null },
      gridLineWidth: 0,
    },
    legend: { enabled: false },
    tooltip: {
      useHTML: true,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      borderWidth: 0,
      shadow: false,
      style: {
        color: '#fff',
        fontFamily: 'Manrope',
        fontSize: '13px',
      },
      formatter: function () {
        const { name, tracked, manual } = this.point.custom;
        return `
          <div style="padding: 8px;">
            <strong>${name}</strong><br/>
            <span style="display:flex;align-items:center;gap:6px;margin-top:4px;">
              <span style="width:8px;height:8px;border-radius:50%;background:#FF8228;display:inline-block;"></span>
              Tracked ${tracked}
            </span>
            <span style="display:flex;align-items:center;gap:6px;">
              <span style="width:8px;height:8px;border-radius:50%;background:#FFBA88;display:inline-block;"></span>
              Manual ${manual}
            </span>
          </div>
        `;
      },
    },
    plotOptions: {
      column: {
        color: '#FF832A',
        borderRadius: 0,
        groupPadding: 0.1,
        pointPadding: 0.05,
        pointWidth: 28,
      },
      series: {
        dataLabels: {
          enabled: true,
          useHTML: true,
          formatter: function () {
            const image = this.point.custom?.image;
            return image
              ? `<div style="margin-bottom: -30px; display: flex; justify-content: center;">
                  <img src="${image}" alt="${this.point.custom.name}" style="min-width: 30px; height: 30px; border-radius: 50%;" />
                </div>`
              : '';
          },
        },
      },
    },
    series: [
      {
        name: 'Hours',
        data: visibleMembers.map((item) => ({
          y: item.hours,
          custom: {
            name: item.name,
            tracked: item.tracked,
            manual: item.manual,
            image: item.image,
          },
        })),
      },
    ],
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />

      <div style={{ textAlign: 'center', marginTop: 12 }}>
      <Stack direction="row" justifyContent="end" spacing={2} mt={2}>
  <Button
    variant="contained"
    color="primary"
    onClick={handlePrev}
    disabled={startIndex === 0}
    startIcon={<ArrowBackIosNewIcon fontSize="small" />}
    sx={{ borderRadius: 2, textTransform: 'none', minWidth: 100 }}
  >
    Previous
  </Button>
  <Button
    variant="contained"
    color="primary"
    onClick={handleNext}
    disabled={startIndex + visibleCount >= allMembers.length}
    endIcon={<ArrowForwardIosIcon fontSize="small" />}
    sx={{ borderRadius: 2, textTransform: 'none', minWidth: 100 }}
  >
    Next
  </Button>
</Stack>

      </div>
    </div>
  );
};

export default MemberUsageBarChart;